(function () {

  // ---- Helpers -------------------------------------------------------------
  function parseOptions(el) {
    const tag = el.querySelector('.slideshow-options[type="application/json"]');
    if (!tag) return {};
    try { return JSON.parse(tag.textContent.trim()); } catch { return {}; }
  }

  function hydrateVideoSources(scope) {
    const videos = (scope || document).querySelectorAll('video');
    videos.forEach((v) => {
      if (v.dataset.hydrated === '1') return;
      const sources = v.querySelectorAll('source[data-src]');
      if (!sources.length) return;
      sources.forEach((s) => {
        s.setAttribute('src', s.getAttribute('data-src'));
        s.removeAttribute('data-src');
      });
      try { v.load(); } catch (_) {}
      v.dataset.hydrated = '1';
    });
  }

  function mountAll(root) {
    const ctx = root || document;
    const nodes = ctx.querySelectorAll('.splide');
    if (!nodes.length) return;

    nodes.forEach((el) => {
      if (el.dataset.splideMounted === '1') return;
      const opts = parseOptions(el);
      const args = (window.splide && window.splide.Extensions) ? window.splide.Extensions : undefined;
      try {
        const inst = new window.Splide(el, opts);
        inst.mount(args);
        el.dataset.splideMounted = '1';
      } catch (e) {
        console.warn('Splide init failed:', e);
      }
      hydrateVideoSources(el);
    });
  }

  function waitForSplide(cb, timeoutMs = 8000) {
    const start = Date.now();
    (function tick() {
      if (window.Splide) return cb();
      if (Date.now() - start > timeoutMs) return cb();
      requestAnimationFrame(tick);
    })();
  }

  function bootstrap(root) { waitForSplide(() => mountAll(root)); }

  document.addEventListener('DOMContentLoaded', () => bootstrap());

  document.addEventListener('shopify:section:load', (e) => bootstrap(e.target));
  document.addEventListener('shopify:section:select', (e) => bootstrap(e.target));
  document.addEventListener('shopify:block:select', (e) => bootstrap(e.target));

  document.addEventListener('turbolinks:load', () => bootstrap());
  document.addEventListener('page:load', () => bootstrap());

  new MutationObserver((muts) => {
    for (const m of muts) {
      if ([...m.addedNodes].some(n => n.nodeType === 1 && n.matches?.('.splide, [class*="splide"]'))) {
        bootstrap(document);
        break;
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  const css = `
    .splide:not(.is-initialized) .splide__track { overflow: visible; }
    .splide:not(.is-initialized) .splide__list { display: flex; gap: 1rem; }
  `;
  const tag = document.createElement('style');
  tag.appendChild(document.createTextNode(css));
  document.head.appendChild(tag);
})();